import { c as _c } from "react/compiler-runtime";
/**
 * @file useErrorConfig.tsx
 * @description
 * -----------------------------------------------------
 * Hook para obtener la configuración de error de la imagen que se usará en el <ErrorView /> según el estado HTTP de la petición
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-12-11
 * @author DLTCode
 * @copyright © DLTCode
 * @license Private
 * */

import { getErrorConfig } from "@/constants/errorConfig";
import { HTTPStatusValue } from "@/constants/HttpStatus";
import { useTheme } from "@/features/theme";
import { useMemo } from "react";

/**
 * Hook que devuelve la configuración de error con la imagen resuelta según el tema actual
 * @param status - Código de estado HTTP opcional
 * @returns Configuración de error con imageSrc como string (ya resuelto según tema)
 */
const useErrorConfig = status => {
  const $ = _c(5);
  const {
    theme
  } = useTheme();
  let t0;
  if ($[0] !== status) {
    t0 = getErrorConfig(status);
    $[0] = status;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const c = t0;
  const t1 = c.imageSrc[theme];
  let t2;
  if ($[2] !== c || $[3] !== t1) {
    t2 = {
      ...c,
      imageSrc: t1
    };
    $[2] = c;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default useErrorConfig;